export { default } from '../../sub/how-it-works';

